import { take, takeLatest, put, select, fork } from 'redux-saga/effects'
import * as apiConstants from 'api/constants'
import { login, createAccount, resetPassword } from 'auth/actions'
import { createVehicle } from 'dashboard-vehicles/actions'
import * as cardConstants from 'credit-cards/constants'
import { subscribeNews, subscribeOffers } from 'wordpress/actions'
import { countryFromHost } from 'shared/country'

import * as constants from 'login-and-signup/constants'
import * as actions from 'login-and-signup/actions'
import * as selectors from 'login-and-signup/selectors'
import featureToggles from 'shared/featureToggles'

function* loginSaga() {
    yield takeLatest(constants.LOGIN_INITIATE, function* (action) {
        const { email, password, remember, translate } = action
        yield put(login(email, password, remember, translate))

        const resultAction = yield take(
            ({ type, names }) => type === apiConstants.PROCESS_FAILED && names[0] === 'login'
        )
        yield put(actions.error(resultAction.error))
    })
}

function* signupSaga() {
    yield takeLatest(constants.SIGNUP_FLOW_INITIATE, function* (action) {
        const {
            firstName,
            lastName,
            email,
            password,
            news,
            offers,
            nif,
            customerType,
            customerRegNr,
            businessName,
            phone,
        } = action
        const country = countryFromHost()

        yield put(
            createAccount(
                firstName,
                lastName,
                email,
                password,
                nif,
                country,
                customerType,
                customerRegNr,
                businessName,
                phone
            )
        )

        const resultAction = yield take(
            ({ type, names }) =>
                (type === apiConstants.PROCESS_COMPLETED || type === apiConstants.PROCESS_FAILED) &&
                names[0] === 'createAccount'
        )

        if (resultAction.type === apiConstants.PROCESS_COMPLETED) {
            if (news) yield put(subscribeNews(email))
            if (offers) yield put(subscribeOffers(email))
            yield put(actions.setAuthFormState(constants.AUTH_CONTAINER_STATE_ACTIVATION))
        } else yield put(actions.error(resultAction.error))
    })
}

function* addVehicleSaga() {
    yield takeLatest(constants.SIGNUP_FLOW_ADD_VEHICLE, function* (action) {
        const { tag, make, model, color, country, state, isRentalCar, rentalExpiryDate } = action

        yield put(createVehicle(tag, make, model, color, country, state, isRentalCar, rentalExpiryDate))

        const resultAction = yield take(
            ({ type, names }) =>
                (type === apiConstants.PROCESS_COMPLETED || type === apiConstants.PROCESS_FAILED) &&
                names[0] === 'createVehicle'
        )

        if (resultAction.type === apiConstants.PROCESS_COMPLETED) {
            yield put(actions.setAuthFormState(constants.AUTH_CONTAINER_STATE_CARDS))
        } else {
            yield put(actions.error(resultAction.error))
        }
    })
}

function* cardSaga() {
    yield takeLatest(cardConstants.ADD_PAYMENT_METHOD_SUCCESS, function* () {
        const { state } = yield select(selectors.authStateSelector)
        if (state === constants.AUTH_CONTAINER_STATE_CARDS)
            yield put(actions.setAuthFormState(constants.AUTH_CONTAINER_STATE_SUCCESS))
    })
}

function* passwordResetSaga() {
    yield takeLatest(constants.SEND_PASSWORD_RESET_EMAIL, function* ({ email }) {
        yield put(resetPassword(email))

        const resultAction = yield take(
            ({ type, names }) =>
                (type === apiConstants.PROCESS_COMPLETED || type === apiConstants.PROCESS_FAILED) &&
                names[0] === 'resetPassword'
        )

        if (resultAction.type === apiConstants.PROCESS_COMPLETED) yield put(actions.resetPasswordSuccess())
        else yield put(actions.error(resultAction.error))
    })
}

export function* rootSaga() {
    yield fork(loginSaga)
    yield fork(signupSaga)
    yield fork(addVehicleSaga)
    yield fork(cardSaga)
    yield fork(passwordResetSaga)
}
